<template>
  <section>
  <v-layout wrap row>
    <v-flex xs4>
    <h1>SEO settings</h1>
    <v-list class="mt-2">
      <v-list-tile v-for="(value, key) in routesData" :key="key">
        <v-list-tile-content>
          <v-list-tile-title>{{value.label}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-tooltip bottom>
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click.stop="editMetadata(key, value)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit metadata</span>
          </v-tooltip>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-btn class="green white--text" @click="submitUpdate">Update</v-btn>
    </v-flex>
  </v-layout>
  <v-dialog persistent v-model="isEditPopupVisible" max-width="600">
    <edit-metadata-form
      :routeData="selectedRoute"
      @metadataChanged="handleMeatadaChange"
    />
  </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { path, isEmpty, assocPath } from 'ramda'
import EditMetadataForm from './editMetadataForm'

export default {
  name: 'SEO',
  components: {
    EditMetadataForm
  },
  data () {
    return {
      selectedRoute: {
        name: null,
        metadata: null
      },
      isEditPopupVisible: false,
      seoContent: null
    }
  },
  computed: {
    ...mapGetters(['staticContent']),
    routesData () {
      return path(['metadata'], this.seoContent)
    }
  },
  methods: {
    ...mapActions(['updateStaticContent', 'fetchStaticContent']),
    editMetadata (name, metadata) {
      this.selectedRoute = { name, metadata }
      this.isEditPopupVisible = true
    },
    handleMeatadaChange (route) {
      this.isEditPopupVisible = false
      this.seoContent = assocPath(['metadata', route.name], route.metadata, this.seoContent)
    },
    submitUpdate () {
      this.updateStaticContent(this.seoContent)
    }
  },
  async created () {
    if (isEmpty(this.staticContent)) {
      await this.fetchStaticContent()
    }
    const category = 'seo'
    this.seoContent = this.staticContent.find(el => el.name === category)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/SEO/index.vue